import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'
import { LoaderService } from '../service/loader.service';
import { ToastrAlertService } from '../service/core/toastr.service';
import { CookiesStorage } from '../service/core/cookies-storage.service';
import { AppTranslateService } from '../service/core/app-translate.service';
import { UserProfileService } from '../service/userProfile.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { AccountService } from '../service/account.service';
import { UserNotificationSetupDto } from '../model/account/UserNotificationSetupDto';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';

@Injectable()
export class MessagingService {

  currentMessage = new BehaviorSubject(null);

  constructor(
    private angularFireMessaging: AngularFireMessaging,
    public loaderService: LoaderService,
    private accountService: AccountService,
    private toastrAlertService: ToastrAlertService,
    private appTranslateService: AppTranslateService,
    private toast: ToastrService,
    private router: Router) {
    var that = this;

    this.angularFireMessaging.messages.subscribe(
      (message) => {
        let audioPlayer = <HTMLVideoElement>document.getElementById("newNotificationSound");
        audioPlayer.play();
        debugger
        var showNotification = true;

        if (showNotification) {
          toast.info(message.data.body, message.data.title, { positionClass: 'toast-bottom-right' }).onTap.subscribe((action) => {
            if (message.data && message.data.local_click_action && message.data.local_click_action !== null && message.data.local_click_action !== "") {
              //window.open("/" + payload.data.local_click_action, "_blank");
              // that.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
              //   that.router.navigate(["/" + message.data.local_click_action]));
              that.router.navigate(["/" + message.data.local_click_action]);
            }
          })
        }

        if ($("#refreshUserNotificationsBtn")) {
          $("#refreshUserNotificationsBtn").click();
        }

      }
    )
  }

  /**
   * update token in firebase database
   *
   * @param userId userId as a key
   * @param token token as a value
   */
  updateToken(userId, token) {
    var currentToken = localStorage.getItem("NotificationToken");
    if (!token || token === null || token === "" || currentToken === token)
      return;
    var newObj: UserNotificationSetupDto = new UserNotificationSetupDto();
    newObj.endpoint = token;
    newObj.userId = userId;
    this.loaderService.show();
    this.accountService.AddNotificationSetup(newObj).subscribe(
      result => {
        if (!result.successed) {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate("generalError"));
        } else {
          localStorage.setItem('NotificationToken', token);
        }
        this.loaderService.hide();
      },
      error => {
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate("generalError"));
        }
        this.loaderService.hide();
      }
    );

  }

  /**
   * request permission for notification from firebase cloud messaging
   *
   * @param userId userId
   */

  requestPermission(userId) {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        this.updateToken(userId, token);
      },
      (err) => {
        console.log(err)
      }
    );
  }
}
